import { WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
export default {
    product: WORK_MANAGEMENT_PRODUCT_ID,
    horizontalPadding: "250px"
};
